import {bymoTemplateMetadataFactoryCreate} from '../../../doppe-sdk';
import type {WixMediaResource} from '@wix/devzai-common-wix';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../../client-server-common';

export namespace BymoTemplatePreRoll {

    export interface TemplateProps {
        preRollMedia: WixMediaResource | null;
    }
}

const initialValues = {
    preRollMedia: null,
} as BymoTemplatePreRoll.TemplateProps;

export const BymoTemplatePreRollTemplateMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplatePreRoll.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: (props) => {
        return {
            ...initialValues,
            ...props
        }
    },
    templatePropsMetadata: {
        preRollMedia: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.SingleMedia, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
    },
    features: [
        'canBeSkipped',
        'hasVisibleBackground',
    ]
})
